import { useEffect, useState } from 'react';
import { HandlingErrorWrappedProps } from '../../../handlingErrors';
import { useCUTranslate } from '../../../util/CUTranslation/hook/useCUTranslate';
import { useControlUnitById } from '../../controlUnit/hooks/useControlUnitById';
import { useAppDispatch, useAppSelector } from '../../store.model';
import { fetchCUParameters } from '../action/thunks';
import {
  getCUParametersComposedFromControlUnit,
  getErrorCUParametersFromControlUnit,
  getLoadingCUParametersFromControlUnit,
} from '../selectors';

export function useCUParameters(
  deviceId: string,
  controlUnitId: string,
  handlingErrorsApi: HandlingErrorWrappedProps['handlingErrorsApi']
) {
  const [, loadingCuTranslate] = useCUTranslate(deviceId, controlUnitId);
  const [, loadingControlUnits, errorControlUnits] = useControlUnitById(
    deviceId,
    controlUnitId,
    handlingErrorsApi
  );

  const composedParameters = useAppSelector((state) =>
    getCUParametersComposedFromControlUnit(state, { deviceId, controlUnitId })
  );

  const loading = useAppSelector((state) =>
    getLoadingCUParametersFromControlUnit(state, { deviceId, controlUnitId })
  );

  const error = useAppSelector((state) =>
    getErrorCUParametersFromControlUnit(state, { deviceId, controlUnitId })
  );

  // Fetch on start
  const [fetch, setFetch] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (fetch) {
      dispatch(fetchCUParameters({ deviceId, controlUnitId }))
        .unwrap()
        .catch(handlingErrorsApi);
      setFetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlUnitId, deviceId, dispatch, fetch]);

  return {
    composedParameters,
    loading: loading || loadingControlUnits || loadingCuTranslate || fetch,
    error: error || errorControlUnits,
  };
}
